import React, { useCallback, useEffect } from 'react';
import FetchZipCode from 'Services/FetchZipCode';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import useDebounce from './useDebounce';

const UseZipCode = (setSearchModel, setValidationModel, ZipCode) => {
    const debouncedSearchTerm = useDebounce(ZipCode, 500)

    const handleSearch = useCallback(async () => {
        if (!debouncedSearchTerm) {
            setSearchModel((prev) => ({ ...prev, city: "", state: "" }));
            setValidationModel((prev) => ({ ...prev, zipCodeError: "" }));
            return
        }else if (debouncedSearchTerm.length < 5) {
            setValidationModel((prev) => ({
                ...prev,
                zipCodeError: (
                    <div className="text-red-500">Zip code must be 5 or 9 digits</div>
                ),
            }));
            setSearchModel((prev) => ({ ...prev, city: "", state: "" }));
            return
        }

        try {
            let zip = debouncedSearchTerm.length > 5 ? debouncedSearchTerm.substring(0, 5) : debouncedSearchTerm;
            const response = await FetchZipCode(zip);
            setSearchModel((prev) => ({
                ...prev,
                city: response.data.dataModel.city,
                state: response.data.dataModel.stateId,
            }))
            setValidationModel((prev) => ({ ...prev, zipCodeError: "" }));
        } catch (error) {
            setValidationModel((prev) => ({
                ...prev,
                zipCodeError: (
                    <div className="text-red-500">{error.response.data.responseMessage}</div>
                ),
            }))
            setSearchModel((prev) => ({ ...prev, city: "", state: "" }));
            ErrorHandlingMessage(error);
        }
    }, [debouncedSearchTerm, setSearchModel, setValidationModel]);

    useEffect(() => {
        handleSearch();
    }, [debouncedSearchTerm, handleSearch]);

    const onPasteZip = (e) => {
        const zipCode = e.target.value;
        setSearchModel((prev) => ({ ...prev, zipCode }));
    };

    return { onPasteZip };
};

export default UseZipCode;
